"use client";

import { useUser } from "@clerk/nextjs";
import { useEffect, useRef } from "react";

import { identifyAnalyticsUser, resetAnalyticsUser } from "@/lib/analytics";
import { getAnalyticsUserIdentity } from "@/lib/posthog-user-identity";

export default function PostHogUserIdentity() {
  const { isLoaded, user } = useUser();
  const previousIdentityKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    const identity = getAnalyticsUserIdentity(user);

    if (identity) {
      if (previousIdentityKeyRef.current !== identity.identityKey) {
        identifyAnalyticsUser(identity.userId, identity.properties);
        previousIdentityKeyRef.current = identity.identityKey;
      }
      return;
    }

    if (previousIdentityKeyRef.current !== null) {
      resetAnalyticsUser();
      previousIdentityKeyRef.current = null;
    }
  }, [isLoaded, user]);

  return null;
}
